import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class AttachmentsPath extends BaseRouteConfig {
  public readonly Index = 'attachments';

  public readonly List = {
    Folder: new ACDLRoute<{ workspaceId: string; attachmentId: string }>(`${this.Path}/:attachmentId`),
    Preview: new ACDLRoute<{ workspaceId: string; attachmentId: string; parentId?: string }>(`${this.Path}/:attachmentId/preview/:parentId?`),
  };
}
